import { computed, Injectable, signal } from '@angular/core';

import { DrawerMode } from '@treetop/shared/model';

@Injectable()
export class DrawerService {
  public isRightResizable = signal(false);
  public isLeftResizable = signal(false);

  public isLeftOpen = signal(false);
  public isRightOpen = signal(false);

  public leftDrawerMode = signal<DrawerMode>('side');
  public rightDrawerMode = signal<DrawerMode>('side');

  public isBackdropVisible = computed(() => {
    return (this.isRightOpen() || this.isLeftOpen()) && (this.leftDrawerMode() === 'over' || this.rightDrawerMode() === 'over');
  });
}
